<template>
  <div class="search-bar">
    <div class="search-container">
      <input
        type="text"
        v-model="searchQuery"
        @input="onSearch"
        placeholder="Search products..."
        class="search-input"
        aria-label="Search products"
      />
      <button class="search-btn" @click="onSearch" aria-label="Search">
        🔍
      </button>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'SearchBar',
  data() {
    return {
      searchQuery: ''
    }
  },
  methods: {
    onSearch: debounce(function() {
      this.$store.dispatch('ecommerce/products/updateSearchQuery', this.searchQuery)
    }, 300)
  }
}
</script>

<style scoped>
.search-bar {
  width: 100%;
}

.search-container {
  position: relative;
  width: 100%;
}

.search-input {
  width: 100%;
  padding: 12px 20px;
  padding-right: 50px;
  border: 2px solid #e9ecef;
  border-radius: 30px;
  font-size: 16px;
  transition: border-color 0.3s ease;
  outline: none;
}

.search-input:focus {
  border-color: #2ed573;
}

.search-btn {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 50%;
  transition: background 0.3s ease;
}

.search-btn:hover {
  background: #f8f9fa;
}
</style>